import {State} from "../store/rootReducers";

export function selectSpinnerStatus(state: State) {
    return state.popup.spinnerStatus;
}

export function selectPopup(state: State) {
    return state.popup;
}
